import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-redirect',
  template: '',
  styleUrls: ['./redirect.component.scss'],
})
export class RedirectComponent implements OnInit {
  constructor() {
    this.redirect();
  }

  ngOnInit(): void {
    this.redirect();
  }

  redirect() {
    window.location.href = 'https://precadastrofidelidade.cacaushow.com.br/';
  }
}
